import { useEffect, type CSSProperties } from 'react';
import { BRAND, paletteVars } from './brand.config';
import { Bento, FaqAccordion, FeatureBlocks, FeatureStrip, FinalCta, Hero, PanelSection, SecurityBlock, SiteFooter, SiteHeader, Steps } from './sections';
import './landing.css';

/** Ajusta title, description e canonical enquanto a landing está na tela e restaura ao sair. */
function useDocumentMeta() {
  useEffect(() => {
    const prevTitle = document.title;
    document.title = BRAND.meta.title;

    let meta = document.querySelector<HTMLMetaElement>('meta[name="description"]');
    const created = !meta;
    if (!meta) {
      meta = document.createElement('meta');
      meta.name = 'description';
      document.head.appendChild(meta);
    }
    const prevDescription = meta.content;
    meta.content = BRAND.meta.description;

    return () => {
      document.title = prevTitle;
      if (created) meta.remove();
      else meta.content = prevDescription;
    };
  }, []);
}

export function LandingPage() {
  useDocumentMeta();
  return (
    <div className="lp-root min-h-dvh" data-lp-theme={BRAND.palette.theme} style={paletteVars(BRAND.palette) as CSSProperties}>
      <a
        href="#conteudo"
        className="sr-only focus:not-sr-only focus:fixed focus:left-3 focus:top-3 focus:z-50 focus:rounded-xl focus:bg-[var(--lp-cta)] focus:px-4 focus:py-3 focus:text-[var(--lp-cta-ink)]"
      >
        Ir para o conteúdo
      </a>
      <SiteHeader />
      <main id="conteudo">
        <Hero />
        <FeatureStrip />
        <PanelSection />
        <Bento />
        <FeatureBlocks />
        <Steps />
        <SecurityBlock />
        <FaqAccordion />
        <FinalCta />
      </main>
      <SiteFooter />
    </div>
  );
}
